import { createSelector } from 'reselect';
import { USER_PRIVACY_STATUS_PRIVATE } from '../../constants/user-privacy-status';

export const getCurrentUser = state => state.currentUser;

export const getCurrentUserId = createSelector(
  [getCurrentUser],
  currentUser => currentUser && currentUser._id,
);

export const getCurrentUserSiteMemberId = createSelector(
  [getCurrentUser],
  currentUser => currentUser && currentUser.siteMemberId,
);

export const getCurrentUserSlug = createSelector(
  [getCurrentUser],
  currentUser => currentUser && currentUser.slug,
);

export const getCurrentUserCounters = createSelector(
  [getCurrentUser],
  currentUser => currentUser && currentUser.counters,
);

export const isOwner = createSelector(
  [getCurrentUser],
  currentUser => Boolean(currentUser && currentUser.isOwner),
);

export const isBlocked = createSelector(
  [getCurrentUser],
  currentUser => Boolean(currentUser && currentUser.isBlocked),
);

export const isPrivate = createSelector(
  [getCurrentUser],
  currentUser => currentUser && currentUser.privacyStatus === USER_PRIVACY_STATUS_PRIVATE,
);

export const getCurrentUserRemainingPosts = createSelector(
  [getCurrentUser],
  currentUser => currentUser && currentUser.remainingPosts,
);
